import { proxy } from 'valtio';

/**
 * Represents a mention that has been selected/recorded
 */
export interface SelectedMention {
  /**
   * Atlassian Account ID of the user who was mentioned
   */
  id: string;
  /**
   * Avatar URL of the user who was mentioned
   */
  avatarUrl: string;
}

/**
 * State for managing selected mentions
 */
export interface MentionState {
  selectedMentions: SelectedMention[];
}

/**
 * Valtio proxy state for selected mentions
 */
export const mentionState = proxy<MentionState>({
  selectedMentions: [],
});

/**
 * Adds a new selected mention to the state
 */
export const addSelectedMention = (mention: SelectedMention) => {
  const newMention: SelectedMention = {
    id: mention.id,
    avatarUrl: mention.avatarUrl,
  };

  if (mentionState.selectedMentions.find((m) => m.id === mention.id)) {
    return;
  }

  mentionState.selectedMentions.push(newMention);
};

/**
 * Clears all selected mentions
 */
export const clearSelectedMentions = () => {
  mentionState.selectedMentions = [];
};
